export default __webpack_public_path__ + "static/media/sleepDayImageActive.cbd47dfc.svg";